const phoneTopImage = require('./images/phone-top.png');
const phoneBottomImage = require('./images/phone-bottom.png');
const phoneBGImage = require('./images/phone-bg.png');

export default {
  mobileView: {
    border: '1px solid rgb(205, 204, 203)',
    zIndex: -1000
  },
  previewMode: {
    mobileView: {
    },
    templateWrapper: {
      marginTop: 140,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: 500,
      height: 'calc(100vh - 302px)',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }
  },
  mobileFrame: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    marginTop: -89,
    zIndex: -1200, // must be bellow mobile page element
  },
  phoneTop: {
    background: `url(${phoneTopImage}) center 0 no-repeat`,
    width: 362,
    height: 89,
    margin: '0 auto'
  },
  phoneBottom: {
    background: `url(${phoneBottomImage}) center 0 no-repeat`,
    width: 362,
    height: 86,
    margin: '0 auto'
  },
  phoneBG: {
    background: `url(${phoneBGImage}) center 0 repeat-y`,
    width: 362,
    margin: '0 auto',
    maxHeight: 500,
    height: 'calc(100vh - 302px)'
  }
};


